/**
 * Shared constants for AdminMetrics sub-components.
 */

export const WINDOW_OPTIONS = [
  { value: "15", label: "15 min" },
  { value: "30", label: "30 min" },
  { value: "60", label: "1 hour" },
  { value: "240", label: "4 hours" },
  { value: "1440", label: "24 hours" },
];

export const API_COLORS = {
  finnhub: "hsl(221, 83%, 53%)",
  yahoo: "hsl(45, 93%, 47%)",
  "exchangerate-api": "hsl(142, 71%, 45%)",
};

export const DYNAMO_COLORS = [
  "hsl(221, 83%, 53%)",
  "hsl(142, 71%, 45%)",
  "hsl(45, 93%, 47%)",
  "hsl(262, 83%, 58%)",
  "hsl(0, 72%, 51%)",
  "hsl(38, 92%, 50%)",
  "hsl(215, 16%, 47%)",
  "hsl(330, 81%, 60%)",
];

export const SUCCESS_COLORS = {
  success: "hsl(142, 71%, 45%)",
  failure: "hsl(0, 72%, 51%)",
};

export function formatUptime(minutes) {
  if (minutes < 60) return `${minutes}m`;
  if (minutes < 1440) return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  return `${days}d ${hours}h`;
}

export function formatMs(ms) {
  if (ms === undefined || ms === null) return "-";
  if (ms < 1) return "<1ms";
  if (ms < 1000) return `${Math.round(ms)}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
}
